export default {
  id: "dreamwalkers",
  pride: 25600,
  slug: "dreamwalkers",
  category: "game",
  status: "archived",
  experienceable: true,
  titleKey: {
    zh: "梦境漫游者",
    en: "Dreamwalkers"
  },
  image: "https://img.itch.zone/aW1nLzIzNDc4MTM0LnBuZw==/315x250%23c/d3qKyA.png",
  descriptionKey: {
    zh: "公元两万年后，机械飞升的人类后裔通过梦境进入灵界探险。虚幻引擎5类幸存者游戏，已有首个demo，目标上Steam。停工。",
    en: "Year 20000+: mechanically ascended human descendants enter the spirit realm through dreaming. UE5 survivors-like game, first demo done, targeting Steam. Archived."
  },
  date: { year: 2025 },
  genres: ["类幸存者", "动作RPG", "联机"],
  themes: ["机械飞升", "灵界", "梦境探索", "世界观PV"],
  engine: "虚幻引擎 5",
  platform: ["PC"],
  developerNotesKey: {
    zh: "托贝诺特世界观下的远未来故事。公元两万年后，肉体人类稀少，机器人成为人类文明继任者。人们开发了做梦的机器，通过梦境连接灵界，意外引发了机械后裔与灵界的激烈冲突。PV通过时间轴展示人类辉煌的过去、机械飞升的历程、以及重新发现灵界的全过程。游戏目标：登上Steam的UE5类幸存者游戏，大量使用高质量素材和VRoid工作流，致力于强化可玩性、绚丽BOSS战、可爱过场动画，支持联机。已完成首个demo，离成品尚有距离，现已停工。",
    en: "A far-future story set in the Tobenot original universe. In the year 20000+, biological humans are scarce and robots are civilization's successors. People build dreaming machines, accidentally bridging the spirit realm and igniting war between mechanical descendants and its guardians. The PV walks through humanity's glorious past, the path of mechanical ascension, and the rediscovery of the spirit realm. Game goal: UE5 survivors-like on Steam, high-quality assets and VRoid workflow, focusing on playability, flashy boss fights, cute cutscenes, and online co-op. First demo complete; production halted."
  },
  tags: ["UE5", "独立游戏"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "itch", url: "https://tobenot.itch.io/dreamwalkers-demo", textKey: { zh: "itch.io 下载 Demo", en: "Download Demo on itch.io" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1JRG2zLEJs/", textKey: { zh: "世界观PV", en: "World Lore PV" } },
    { type: "download", url: "https://pan.baidu.com/s/1PAqQLrJmgxOTvPSbZWZRuA?pwd=2000", textKey: { zh: "Demo 下载（提取码 2000）", en: "Demo Download (code: 2000)" } }
  ]
};
